import React from 'react';
import { componentService } from 'js/services/component.service';

export const UnauthorizedNotification = React.lazy(() => import(/* webpackChunkName: "unauthorized-notification" */ './UnauthorizedNotification'));

componentService.registerPageComponents({ unauthorizednotification: UnauthorizedNotification });
